import { Store } from 'store/index';
import { ProductType } from '../types';
import getPersonalisedProductPageSelectors from './getPersonalisedProductPageSelectors';
import getPredesignedProductPageSelectors from './getPredesignedProductPageSelectors';
import getProductType from './getProductType';

const getProductPageSelectors = (store: Store) => {
  const productType = getProductType(store);
  switch (productType) {
    case ProductType.predesigned:
      return getPredesignedProductPageSelectors(store);
    case ProductType.personalized:
      return getPersonalisedProductPageSelectors(store);
    default:
      return [];
  }
};

export default getProductPageSelectors;
